import {
  centraCheckoutApiProductToGreaseProductMedia,
  CentraCheckoutApiMappers,
} from "@made-people/grease-centra";
import { ProductMedia } from "@made-people/grease-product";

export const mmProductMedia: CentraCheckoutApiMappers["centraCheckoutApiProductToGreaseProductMedia"] =
  (product, options) => {
    const videoUrl = product.variant_product_video_carousel_text;
    const videoPosition = 2;
    const productMedia = centraCheckoutApiProductToGreaseProductMedia(
      product,
      options,
    );

    if (typeof videoUrl !== "string") {
      return productMedia;
    }

    const videoMediaObject: ProductMedia = {
      type: "video",
      src: videoUrl,
      poster: "",
    };

    let position = 1;
    if (
      typeof videoPosition === "string" ||
      typeof videoPosition === "number"
    ) {
      const parsedPosition = Number(videoPosition);
      if (!isNaN(parsedPosition)) {
        position = parsedPosition - 1;
      }
    }

    position = Math.max(0, Math.min(position, productMedia.length));

    return [
      ...productMedia.slice(0, position),
      videoMediaObject,
      ...productMedia.slice(position),
    ];
  };
